// src/context/AuthContext.js

import React, { createContext, useState, useEffect } from "react";

import AuthService from "../services/auth";

export const AuthContext = createContext({
  user: null,
  login: async () => null,
  logout: () => {},
});

export const AuthProvider = ({ children }) => {
  // authData = { access, refresh, user } or null
  const [authData, setAuthData] = useState(() => AuthService.getCurrentUser());
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // AuthService has already set up axios defaults
    setLoading(false);
  }, []);

  const login = async (identifier, password) => {
    const data = await AuthService.login(identifier, password);
    setAuthData(data);
    return data.user;
  };

  const logout = () => {
    AuthService.logout();
    setAuthData(null);
  };

  if (loading) return null;

  return (
    <AuthContext.Provider value={{
      user: authData?.user || null,
      login,
      logout
    }}>
      {children}
    </AuthContext.Provider>
  );
};
